export default class GetShareStats {
  constructor(url, container) {
    this.url = url;
    this.container = container;
    this.totalShares = 0;
    this.smsShares = parseInt($(`${this.container} .sms-shares`).data("number"));
    this.emailShares = parseInt($(`${this.container} .email-shares`).data("number"));

    this.totalShares += this.smsShares;
    this.totalShares += this.emailShares;

    const facebookPromise = this.getFacebookShares();
    const twitterPromise = this.getTwitterShares();

    Promise.all([facebookPromise, twitterPromise]).then(() => {
      this.setTotalShares();
    });
  }

  getFacebookShares() {
    return this._request(`//graph.facebook.com/?id=${encodeURIComponent(this.url)}`).then(
      (data) => {
        let shares = data.share ? parseInt(data.share.share_count) : 0;
        this.facebookShares = shares;
        this.totalShares += shares;
        $(`${this.container} .facebook-shares .number`).html(shares);
        return shares;
      },
    );
  }

  getTwitterShares() {
    return new Promise((resolve) => {
      // data is from stat sums from the cmapaign page
      const data = $(".twitter-shares").data("number");
      const shares = data ? parseInt(data) : 0;
      this.twitterShares = shares;
      this.totalShares += shares;

      resolve();
    });
  }

  setTotalShares() {
    let totalShares = this.totalShares;
    $(`${this.container} .campaign-total-shares`).html(totalShares);
  }

  _request(url) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url,
        type: "GET",
        dataType: "JSONP",
      })
        .done((data) => resolve(data))
        .fail((error) => reject(error));
    });
  }
}
